// This looks weird, but it's the only feasible way to control, trough webpack,
// which themes gets bundled in the build

/* eslint-disable import/no-unresolved */
import { Theme as theme0, ThemeProvider as tp0, breakpoints as bp0 } from 'exo_theme_0';
import { Theme as theme1, ThemeProvider as tp1, breakpoints as bp1 } from 'exo_theme_1';
import { Theme as theme2, ThemeProvider as tp2, breakpoints as bp2 } from 'exo_theme_2';
import { Theme as theme3, ThemeProvider as tp3, breakpoints as bp3 } from 'exo_theme_3';
import { Theme as theme4, ThemeProvider as tp4, breakpoints as bp4 } from 'exo_theme_4';
import { Theme as theme5, ThemeProvider as tp5, breakpoints as bp5 } from 'exo_theme_5';
import { Theme as theme6, ThemeProvider as tp6, breakpoints as bp6 } from 'exo_theme_6';
import { Theme as theme7, ThemeProvider as tp7, breakpoints as bp7 } from 'exo_theme_7';
import { Theme as theme8, ThemeProvider as tp8, breakpoints as bp8 } from 'exo_theme_8';
import { Theme as theme9, ThemeProvider as tp9, breakpoints as bp9 } from 'exo_theme_9';

export default () => [theme0, theme1, theme2, theme3, theme4, theme5, theme6, theme7, theme8, theme9].filter((t) => t.name)

export const themes = [theme0, theme1, theme2, theme3, theme4, theme5, theme6, theme7, theme8, theme9];
export const providers = [tp0, tp1, tp2, tp3, tp4, tp5, tp6, tp7, tp8, tp9];
export const breakpoints = [bp0, bp1, bp2, bp3, bp4, bp5, bp6, bp7, bp8, bp9];